import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import { findGa4Pixel, initGa4, trackGa4PageView, type PublicPixel } from '@/lib/ga4';

/**
 * Loads active marketing pixels from CMS and wires GA4 SPA pageviews.
 * Mount only on the storefront (not admin).
 */
export function PixelTracker() {
  const location = useLocation();

  const { data: pixels } = useQuery({
    queryKey: ['cms', 'pixels'],
    queryFn: () => api.get<PublicPixel[]>('/cms/pixels'),
    staleTime: 5 * 60_000,
    retry: 1,
  });

  useEffect(() => {
    const ga4 = findGa4Pixel(pixels ?? []);
    if (!ga4) return;

    initGa4(ga4.pixelId);
    trackGa4PageView(`${location.pathname}${location.search}`);
  }, [pixels, location.pathname, location.search]);

  return null;
}
